import { createWebHistory, createRouter } from "vue-router";
import { Auth } from 'aws-amplify'
import AuthComponent from '../components/Auth'
import Tools from "../components/Tools";

const routes = [
  {
    path: "/tools",
    name: "tools",
    component: Tools,
    meta: { requiresAuth: true },
  },
  {
    path: "/auth",
    name: "auth",
    component: AuthComponent,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeResolve((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    Auth.currentAuthenticatedUser().then(() => {
      next()
    }).catch(() => {
      next({
        path: '/auth'
      });
    });
  } else {
    next()
  }
})

export default router;